// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

// Handles the clicking of the SELECT button when issueing assets to BOMS

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "vlreads" ]
  static values = {
    data: Array,
    background: String,
    ylabel: String,
    ylabelColor: String,
    ylabelTitle: String,
    ylabelType: String,
    ylabelSort: String,
    y1label: String,
    y1labelColor: String,
    y1labelTitle: String,
    y1labelType: String,
    y1labelSort: String,
    xlabel: String,
    xlabelTitle: String,
    xlabelType: String,
    xlabelSort: String,
    title: String
  }

  connect() {
    let vlSpec = {
      $schema: 'https://vega.github.io/schema/vega-lite/v5.json',
      data: {
        values: this.dataValue,
      },
      background: this.backgroundValue,
      width: 'container',
      mark: 'bar',
      encoding: {
        x: {
          field: this.xlabelValue,
          type: this.xlabelTypeValue,
          title: this.xlabelTitleValue,
          sort: this.xlabelSortValue
        }
      },
      layer: [
        {
          mark: {
            opacity: 0.3, 
            type: "bar", 
            color: this.ylabelColorValue
          },
          encoding: {
            y: {
              field: this.ylabelValue,
              type: this.ylabelTypeValue,
              title: this.ylabelTitleValue,
              sort: this.ylabelSortValue,
              axis: {
                titleColor: this.ylabelColorValue
              }
            },
            tooltip: [
              {
                field: this.ylabelValue,
                type: this.ylabelTypeValue,
                title: this.ylabelTitleValue
              },
              {
                field: this.y1labelValue,
                type: this.y1labelTypeValue,
                title: this.y1labelTitleValue
              }
            ]
          }
        },
        {
          mark: {
            opacity: 0.3, 
            type: "point", 
            color: this.y1labelColorValue
          },
          encoding: {
            y: {
              field: this.y1labelValue,
              type: this.y1labelTypeValue,
              title: this.y1labelTitleValue,
              sort: this.y1labelSortValue,
              axis: {
                titleColor: this.y1labelColorValue
              }
            }
          }
        },
      ],
      resolve: {
        scale: {
          y: "independent"
        }
      },
      title: this.titleValue
    };
    
    vegaEmbed(this.vlreadsTarget, vlSpec, {"actions": false});
  }
}
